var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpToknojd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 97,
    viewBox: "0 0 88 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 81.2499C5.23595 84.4961 8.49953 88.1327 12.1056 90.9363C15.4419 93.5301 17.8802 97.0938 20.9654 93.436C23.0864 90.9214 25.3261 88.9786 28.0255 87.0131C31.7792 84.28 36.5505 82.7684 40 80",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0587 75.4929C14.3355 71.8471 16.9876 68.3281 18.9065 64.5277",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9695 61.9422C25.5454 62.4645 21.4873 73.3329 26.5301 69.5817C29.8341 67.1239 29.538 64.1324 26.2844 62.1006",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3374 48.7539C28.2621 52.7542 30.5849 56.3843 32.1085 60.201C32.5854 61.3956 33.9987 53.9777 34.4949 52.3119C35.881 47.659 34.7946 54.0721 34.3262 55.3981C33.6622 57.2779 38.6029 55.5322 39.6728 55.2849",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5091 44.0061C38.9985 46.123 40.4936 50.291 42.655 51.1872C44.3531 51.8914 41.235 47.7183 41.148 45.8821C40.9131 40.9205 45.1591 40.8932 47.7323 43.3176",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7326 36.3599C50.9779 41.7473 57.4825 35.3189 53.9483 34.3029C52.1445 33.7843 50.3048 29.8115 49.0458 31.8275C47.5389 34.2405 47.5322 36.2075 48.1524 38.8903",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4861 28.1201L43.7978 29.4682",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2553 24.1776C47.8274 24.8627 47.6028 25.5442 47.3227 26.2867",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0631 24.7285C56.0576 27.1412 61.9158 33.5553 58.769 36.8952",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7802 20.9958C51.5964 20.3707 51.2482 19.8464 50.9153 19.3022",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9859 14.8717C64.9125 15.1198 62.7984 14.503 62.1259 15.5798C61.3349 16.8465 62.1092 19.501 62.7117 20.7304C63.8444 23.042 65.7819 21.2164 66.6849 19.9435C68.4187 17.4994 67.8991 15.7945 66.308 13.193C65.2688 11.4938 63.6685 10.2882 62.6304 8.54667C61.7096 7.00198 59.8346 4.2482 62.2976 6.99309C65.4718 10.5305 67.9518 14.9299 72.5548 16.6669",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0362 2.59693C72.815 4.80263 72.2119 7.54825 72.8981 9.96063C73.8409 13.2755 77.0599 10.1653 77.0841 8.04627C77.1012 6.55341 76.5373 4.84202 75.5135 3.75447C74.3039 2.46965 78.6775 5.35926 80.3674 5.8672C83.6341 6.8491 85.9234 7.29797 85.9974 3.1457",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0571 62.9126C11.7998 65.4699 14.7309 67.9912 16.0954 70.3739C17.4265 72.6983 19.7891 76.3522 22.0901 77.8771C24.9829 79.7942 26.7235 75.3948 26.2022 73.1396",
    stroke: "#FFA0FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpToknojd);
export default __webpack_public_path__ + "static/media/lp-toknojd.f4338f270499b73b3e0f91b78abd7ebc.svg";
export { ForwardRef as ReactComponent };